import React, { useCallback, useMemo } from "react";
import { ChangeEventHandler } from "react";
import { SearchFilterProps } from "./search-filter";

export type SearchFilterControllerProps = Omit<SearchFilterProps, "tagList">;

export const useSearchFilterController = ({
  productList,
  selectedProductId,
  selectedTags,
  onChangeProduct,
  onChangeTags,
}: SearchFilterControllerProps) => {
  const product = useMemo(() => {
    return selectedProductId
      ? productList.find(
          (product) => product.id === selectedProductId.toString(),
        )
      : undefined;
  }, [productList, selectedProductId]);
  const handleOnProductChange: ChangeEventHandler<HTMLInputElement> =
    useCallback(
      (e) => {
        onChangeProduct(e.target.value);
      },
      [onChangeProduct],
    );

  const handleOnTagChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value, checked } = event.target;
      const checkedIds = checked
        ? [...selectedTags, value]
        : selectedTags.filter((tag) => tag !== value);
      onChangeTags(checkedIds);
      return checkedIds;
    },
    [onChangeTags, selectedTags],
  );
  return {
    productList,
    product,
    selectedProductId,
    selectedTags,
    handleOnProductChange,
    handleOnTagChange,
  };
};
